import { render, staticRenderFns } from "./SMSPopup.vue?vue&type=template&id=9a2f7d76&scoped=true&"
import script from "./SMSPopup.vue?vue&type=script&lang=js&"
export * from "./SMSPopup.vue?vue&type=script&lang=js&"
import style0 from "./SMSPopup.vue?vue&type=style&index=0&id=9a2f7d76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2f7d76",
  null
  
)

export default component.exports